import { render, staticRenderFns } from "./ProtectionSystem.vue?vue&type=template&id=0f77b028&scoped=true"
import script from "./ProtectionSystem.vue?vue&type=script&lang=js"
export * from "./ProtectionSystem.vue?vue&type=script&lang=js"
import style0 from "./ProtectionSystem.vue?vue&type=style&index=0&id=0f77b028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77b028",
  null
  
)

export default component.exports